import { AppShell } from '../../components/layout/AppShell';
import { PageLayout } from '../../components/common/PageLayout';
import { ContentCard } from '../../components/common/ContentCard';
import { PAGE_COLORS } from '../../utils/pageColors';

export const CartlinksPage: React.FC = () => {
  return (
    <AppShell>
      <PageLayout
        title="Cartlinks"
        subtitle="Create and manage cart links"
        bgColor={PAGE_COLORS.orders.bgColor}
        textColor={PAGE_COLORS.orders.textColor}
        borderColor={PAGE_COLORS.orders.borderColor}
        icon={<></>}
      >
        <ContentCard>
          <p className="text-gray-600">Cartlinks management page coming soon...</p>
        </ContentCard>
      </PageLayout>
    </AppShell>
  );
};
